import { Nullable } from '@clearverify/types';

import { EmployerStaffWhere } from 'src/api';
import { getUserFullNameFilter } from 'src/utils/user';

export const prepareSearchStaffsFilter = (searchValue: Nullable<string>): EmployerStaffWhere => {
  return searchValue && searchValue.length > 0
    ? {
        user: getUserFullNameFilter(searchValue),
      }
    : {};
};
